import { MODES } from '../../../global/constants/scheduler'

export function isSchedulerPublicFacing(mode: string) {
  return [
    MODES.CUSTOMER as string,
    MODES.CUSTOMER_RESCHEDULE as string,
  ].includes(mode)
}
